/* eslint-disable no-use-before-define */
import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";

import GlobalApi from "./../../Global";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";

function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== "undefined"
    ? isoCode
        .toUpperCase()
        .replace(/./g, (char) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
        )
    : isoCode;
}

const useStyles = makeStyles({
  option: {
    fontSize: 10,
    "& > span": {
      marginRight: 0,
      fontSize: 10,
    },
  },
});



export default function CountrySelect(props) {

  const [templates, setTemplates] = React.useState([])


  React.useEffect(() => {
    fetchTemplate()
  }, [])

  const onTempChange = (event, values) => {
    if (values !== null) {
      console.log("asd", values)
      props.template(values.id);
    } else {
      if (values == null) {
        values = "cleared";
        props.template(values.id);
      }
    }
  };

  const fetchTemplate = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      organization_id: data.organization_id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Template/get_all_templates?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response, "{}{}{}{}");
        if (response.status === "Success") {
          setTemplates(response.data)

        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchTemplate();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };
  const onAssigneeChange = (event, values) => {
    if (values !== null) {
      props.assignee(values.id);
    } else {
      if (values === null) {
        values = "cleared";
        props.assignee(values);
      }
    }
  };

  const classes = useStyles();
  return (
    <React.Fragment>
      <Autocomplete
        // id="country-select-demo"
        style={{ width: 230 }}
        options={templates}
        onChange={onTempChange}
        classes={{
          option: classes.option,
        }}
        autoHighlight
        getOptionLabel={(option) => option.title}
        renderOption={(option) => (
          <React.Fragment>{option.title}</React.Fragment>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Template"
            variant="outlined"
            inputProps={{
              ...params.inputProps,
              // autoComplete: "new-password", // disable autocomplete and autofill
            }}
          />
        )}
      />
      <br />
      <Autocomplete
        // id="country-select-demo"
        style={{ width: 230, display: props.hideAssignee ? "none" : "block" }}
        options={props.users}
        onChange={onAssigneeChange}
        classes={{
          option: classes.option,
        }}
        autoHighlight
        getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
        renderOption={(option) => (
          <React.Fragment>{option.first_name} {option.last_name}</React.Fragment>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Assignee"
            variant="outlined"
            inputProps={{
              ...params.inputProps,
              // autoComplete: "new-password", // disable autocomplete and autofill
            }}
          />
        )}
      />
    </React.Fragment>
  );
}

const Templates = [
  { Template: "Workplace Reopening Checklist for COVID -19" },
  { Template: "Workplace Reopening Checklist for COVID -18" },
];

const Assignee = [{ Assignee: "Finesols" }, { Assignee: "Skypotential Team" }];
